<template>
  <div class="contacts">
    <h1>Contatti</h1>

    <div class="contatti__first-box">
      <div class="contatti__first-box__abox">
        <div class="contatti__first-box__abox__line">
          <span class="contatti__fist-box__abox__line__title">Raggiungici</span>
          <span class="contatti__fist-box__abox__line__content">
            Laboratorio Polo<br />
            Via Verdi, 32<br />
            31046 Oderzo - TV<br />
            ITALIA
          </span>
        </div>
      </div>

      <div class="contatti__first-box__abox">
        <div class="contatti__first-box__abox__line">
          <span class="contatti__fist-box__abox__line__title">Email</span>
          <span class="contatti__fist-box__abox__line__content">info@pololab.com</span>
        </div>

        <div class="contatti__first-box__abox__line">
          <span class="contatti__fist-box__abox__line__title">Telefono</span>
          <span class="contatti__fist-box__abox__line__content">+39 0422 815518</span>
        </div>

        <div class="contatti__first-box__abox__line">
          <span class="contatti__fist-box__abox__line__title">Fax</span>
          <span class="contatti__fist-box__abox__line__content">+39 0422 716302</span>
        </div>
      </div>
    </div>

    <div class="contatti__choose-route">
      <div class="contatti__choose-route__title">Seleziona un argomento</div>

      <ul class="contatti__choose-route__route__list">
        <li
          class="contatti__choose-route__route"
          :class="{ 'contatti__choose-route__route--active': $route.name === 'info-contacts' }">
          <router-link :to="{ name: 'info-contacts' }">Richiesta di informazioni</router-link>
        </li>
        <li
          class="contatti__choose-route__route"
          :class="{ 'contatti__choose-route__route--active': $route.name === 'job-contacts' }">
          <router-link :to="{ name: 'job-contacts' }">Lavora con noi</router-link>
        </li>
      </ul>
    </div>

    <router-view />

    <div
      v-fade-on-scroll="$_onScroll"
      class="contact-bottom-button contact-bottom-button--close"
      @click="$router.go(-1)"
      @mouseover="updateMouseCursor('button')"
      @mouseout="updateMouseCursor('default')"></div>
  </div>
</template>

<script>

import SiteLogo from './../components/SiteLogo'
import GlobalNavigationTop from './../components/GlobalNavigationTop'

export default {
  components: {
    SiteLogo,
    GlobalNavigationTop
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';
@import '../assets/scss/mixins.scss';

.contacts {
  background-color: #f2f2f2;

  color: #0a2f74;
  position: absolute;
  width: 100vw;
  min-height: 100vh;
  z-index: 190;
  padding: 10rem 7.5%;
  box-sizing: border-box;

  @include media(">=large") {
    padding: 30rem 15% 10rem 15%;
  }

  #typo {
    display: none;
  }

  .global-navigation__menu {
    display: none;
  }

  h1 {
    margin: 0 0 10rem 0;
    font-size: 4.25rem;
    line-height: 1;

    @include media(">=large") {
      font-size: 13rem;
    }
  }

  .contatti__first-box {
    font-size: 2rem;
    margin-bottom: 130px;

    @include media(">=large") {
      display: flex;
    }
  }

  .contatti__first-box__abox {
    @include media(">=large") {
      margin-right: 15%;
    }
  }

  .contatti__first-box__abox__line {
    margin-bottom: 2rem;

    @include media(">=large") {
      display: flex;
    }
  }

  .contatti__fist-box__abox__line__title {
    font-weight: 600;
    width: 170px;

    &::after {
      content: ":";
    }

    @include media(">=large") {
      &::after {
        content: "";
      }
    }
  }

  .contatti__choose-route__title {
    font-weight: bold;
  }

  .contatti__choose-route {
    margin-bottom: 100px;
  }

  .contatti__choose-route__route__list {
    padding: 0;

    @include media(">=large") {
      display: flex;
    }
  }

  .contatti__choose-route__route {
    list-style: none;
    padding: 0;
    margin: 0;
    color: #0a2f74;
    font-size: 2rem;
    margin-right: 10rem;
    white-space: nowrap;

    @include media(">=large") {
      font-size: 3.1rem;
    }

    a {
      text-decoration: none;
      color: #0a2f74;
      position: relative;

      &:after {
        display: block;
        content: "";
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: #0a2f74;
        transform: scaleX(0);
        transform-origin: right;
        transition: transform .3s ease-out;
      }

      &:hover {
        &:after {
          transform: scaleX(1);
        }
      }
    }

    &.contatti__choose-route__route--active a::after {
      transform: scaleX(1);
    }
  }
}

.contacts__form {
  margin-top: 100px;
}

.contacts__form__element {
  width: 100%;
  display: inline-block;
  min-height: 12.5rem;
  position: relative;

  @include media(">=large") {
    width: 47.5%;
  }

  &:nth-child(odd) {
    @include media(">=large") {
      margin: 0 0 0 5%;
    }
  }

  &.contacts__form__element--full-width {
    width: 100%;
    margin: 0;
  }

  input {
    width: 100%;
    background-color: #f2f2f2;
    border: none;
    border-bottom: 2px solid #e2dde6;
    padding-bottom: 1.75rem;
    font-size: 2rem;
    color: #0a2f74;

    &:focus {
      border-bottom: 2px solid #0b3277;
    }
  }

  .errorinput{
    border-bottom: 2px solid #ae4f71;
  }

  input[type="file"]{
    font-size: 1.8rem;
    padding-bottom: 1.5rem;
    border-bottom: 0;
  }

  textarea:focus, input:focus, select:focus {
    outline: none;
  }

  select {
    width: 100%;
    background-color: #f2f2f2;
    border: none;
    border-bottom: 2px solid #e2dde6;
    padding-bottom: 1.75rem;
    font-size: 2rem;
    color: #0a2f74;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDIxIDEyIj4gICAgPHBhdGggZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiM1NjI0ODEiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS13aWR0aD0iMS44IiBkPSJNMTkuNSAxLjVsLTkgOS05LTkiLz48L3N2Zz4=);
    background-position: right;
    background-repeat: no-repeat;
    appearance: none;
  }

  .contacts__form__element_error{
    position: absolute;
    top: 95px;
    left: 0;
    font-size: 1.2rem;
    color: #ae4f71;
  }
}

.contacts__from__element__placeholder {
  font-size: 1.8rem;
  transform: translateY(45px) scale(1);
  pointer-events: none;
  transform-origin: left;
  transition: all .3s;
}

.contacts__form__element--no-margin {
  margin: 0 5% 0 0 !important;
}

.contacts__form__element--checkbox {
  display: inline-block;

  label {
    font-size: 1.2rem;

    div {
      width: 70%;
      transform: translateX(40px) translateY(-40px);

      @media all and (min-width: 530px) {
        transform: translateX(40px) translateY(-30px);
      }
    }

    @include media(">=large") {
      white-space: nowrap;
    }
  }

  label::before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2dde6;
    vertical-align: middle;
    margin: 0 1rem 0 0;
    line-height: 30px;
    text-align: center;
    font-size: 20px;
  }

  label.errorinput{
    border-bottom: 0 !important;
  }

  label.errorinput::before {
    border: 1px solid #ae4f71;
  }

  input:checked + label::before {
    content: "■";
  }

  input {
    opacity: 0;
  }
}

.contacts__form__element--send-button {
  text-align: center;
  padding: 5rem 2rem;
  box-sizing: border-box;

  @include media(">=large") {
    text-align: right;
  }

  button {
    cursor: pointer;
    border: none;
    background-color: #f2f2f2;
    color: #0488a3;
    font-size: 3.1rem;
    outline: none;
    position: relative;
    padding: 0;

    &:after {
      display: block;
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: #0a2f74;
      transform: scaleX(1);
      transform-origin: right;
      transition: transform .3s ease-out;
    }

    @include media(">=large") {
      &:after {
        transform: scaleX(0);
      }
    }

    &:hover {
      &:after {
        transform: scaleX(1);
      }
    }
  }
}

.contacts__form__element--hide-placeholder {
  .contacts__from__element__placeholder {
    transform: translateY(0) scale(.9);
  }
}

</style>
